import { useLocation } from "wouter";
import { CreditCard, Star, BookOpen, Trophy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface PaymentFailedScreenProps {
  user: {
    firstName?: string | null;
    xp?: number | null;
    level?: number | null;
  };
}

export function PaymentFailedScreen({ user }: PaymentFailedScreenProps) {
  const [, setLocation] = useLocation();
  const childName = user.firstName || "there";

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="flex justify-center">
          <div className="rounded-full bg-amber-100 p-5">
            <CreditCard className="w-12 h-12 text-amber-600" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight">
            Your account is on a short break!
          </h1>
          <p className="text-muted-foreground">
            Hey {childName}! Ask your parent or guardian to check their WhatsApp or email to get you back on track.
          </p>
        </div>

        {(user.xp || user.level) && (
          <Card>
            <CardContent className="pt-5 pb-5">
              <p className="text-sm font-medium mb-3">Your progress so far</p>
              <div className="flex justify-center gap-6 text-sm">
                {user.level && (
                  <div className="flex items-center gap-1.5">
                    <Star className="w-4 h-4 text-amber-500" />
                    <span>Level {user.level}</span>
                  </div>
                )}
                {user.xp && (
                  <div className="flex items-center gap-1.5">
                    <Trophy className="w-4 h-4 text-purple-500" />
                    <span>{user.xp.toLocaleString()} XP</span>
                  </div>
                )}
              </div>
            </CardContent>
          </Card>
        )}

        <div className="space-y-3">
          <Button
            variant="default"
            className="w-full"
            onClick={() => setLocation("/settings?tab=billing")}
          >
            <CreditCard className="w-4 h-4 mr-2" />
            Go to Billing
          </Button>
        </div>

        <p className="text-xs text-muted-foreground">
          Need help? Contact us at{" "}
          <a href="mailto:hello@edufocalgroup.com" className="underline underline-offset-2">
            hello@edufocalgroup.com
          </a>
        </p>
      </div>
    </div>
  );
}
